import { Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api/api.service';
import { CourseSectionI } from './interfaces/course-section.interface';
import { FilterSectionsForCourseI } from '../courses/interfaces/filter-sections-for-courses.interface';
import { FilterCourseSectionsI } from './interfaces/filter-course-sections.interface';
import { FetchCourseSectionReportI } from './dtos/fetch-course-section-report.dto';
import { CourseSectionReportI } from './interfaces/course-section-report.interface';
import { CreateJustificationDto } from './dtos/create-justification.dto';
import { FilterCourseClosDto } from '../courses/dtos/filter-clos.dto';
import { CloI } from '../courses/interfaces/clo.interface';

@Injectable({
  providedIn: 'root',
})
export class CourseSectionsApiService {
  constructor(private readonly apiService: ApiService) {}

  findAll(filterCourses: FilterCourseSectionsI) {
    return this.apiService.get<CourseSectionI[]>(
      'course-sections',
      filterCourses
    );
  }
  findAllCourseSectionsForCourse(
    filterCourseSectionsForCourse: FilterSectionsForCourseI
  ) {
    return this.apiService.get<CourseSectionI[]>(
      'course-sections',
      filterCourseSectionsForCourse
    );
  }

  findOne(courseSectionID: string) {
    return this.apiService.get<CourseSectionI>(
      `course-sections/${courseSectionID}`
    );
  }

  report(
    courseSectionID: string,
    createCourseSectionReport: FetchCourseSectionReportI
  ) {
    return this.apiService.get<CourseSectionReportI>(
      `course-sections/${courseSectionID}/report`,
      createCourseSectionReport
    );
  }
  complete(courseSectionID: string) {
    return this.apiService.patch<CourseSectionI>(
      `course-sections/${courseSectionID}/complete`
    );
  }
  createJustification(
    courseSectionID: string,
    createJustificationDto: CreateJustificationDto
  ) {
    return this.apiService.post<CourseSectionI>(
      `justifications/${courseSectionID}`,
      createJustificationDto
    );
  }
  findAllClos(courseID: string, filterCourseClosDto: FilterCourseClosDto) {
    return this.apiService.get<CloI[]>(
      `clos/course-sections/${courseID}`,
      filterCourseClosDto
    );
  }
}
